/* eslint-disable react/prop-types */
import React from 'react';
import uniqid from 'uniqid';
import { Newsletter } from 'Components/organisms/Newsletter';

import 'Styles/components/organisms/_Newsletter.scss';

export const getNewsletter = ({
  props,
  newsletterConfig,
  additionalProps,
}) => {
  if ((typeof props !== 'object' || Object.keys(props).length === 0)
      && (typeof newsletterConfig !== 'object' || Object.keys(newsletterConfig).length === 0)) {
    return false;
  }

  const {
    mainTitle,
    title,
    ctaLabel,
    ctaUrl,
    placeholder,
    subtitle,
    extraClassNames,
    position,
    showLink,
  } = props;

  return (
    <Newsletter
      key={uniqid()}
      mainTitle={newsletterConfig.mainTitle || mainTitle}
      title={newsletterConfig.title || title}
      cta_label={newsletterConfig.ctaLabel || ctaLabel}
      formUrl={((newsletterConfig.newsletterURL || newsletterConfig.ctaUrl || ctaUrl)) || ''}
      placeholder={newsletterConfig.placeholder || placeholder}
      subtitle={newsletterConfig.subtitle || subtitle}
      extraClassNames={extraClassNames || {}}
      position={position}
      showLink={newsletterConfig.showLink || showLink}
      {...additionalProps}
    />
  );
};
